import React from 'react';
import { Tag } from '@innovationnorway/cl-react';
import { OneWayInServiceDto } from 'src/api/v2';
import './ServiceInfo.scss';
import i18next from 'i18next';
import { sanitizeD365RichTextEditor } from 'src/features/one-way-in/utils/htmlTextConverter';

const ServiceInfo = ({ row }: { row: { original: OneWayInServiceDto } }) => {
  const { t } = i18next;
  const companyAge = row.original.companyAge;

  return (
    <div className="service-info">
      <div
        className="service-info__description"
        dangerouslySetInnerHTML={{ __html: sanitizeD365RichTextEditor(row.original.description || '') }}
      />
      <div className="service-info__details">
        <div className="service-info__details--type">
          <p className="font-weight--bold">{t<string>('tableTitles:deliveryTypes')}</p>
          <div className="service-info__tags">
            {row.original.deliveryTypes.map((type, index) => (
              <Tag data-color={'accent' as const} key={index}>
                {t<string>(`oneWayIn:deliveryType.${type}`)}
              </Tag>
            ))}
          </div>
        </div>
        <div className="service-info__details--requirements">
          <p className="font-weight--bold">{t<string>('oneWayIn:referring.requirements')}</p>
          <p>
            {t<string>('oneWayIn:referring.companyAge')}:{' '}
            {companyAge ? t<string>(`oneWayIn:companyAge.${companyAge}`, { defaultValue: companyAge }) : ''}
          </p>
          <div className="service-info__tags">
            <span>{t<string>('accountProfile:companySize')}:</span>
            {row.original.companySize?.map((size) => (
              <Tag data-color={'accent' as const} key={size}>
                {t<string>(`oneWayIn:companySize.${size}`, { defaultValue: size })}
              </Tag>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceInfo;
